const STRING_START_INDEX = 0;
export const VISIBLE_CHARACTERS = 2;

export function obfuscate(input: string | number | undefined, numCharsToObfuscate?: number): string {
  if (!input) return '';

  const str = input.toString();
  const { length } = str;

  if (!numCharsToObfuscate) {
    return '*'.repeat(length);
  }

  if (length <= VISIBLE_CHARACTERS) {
    return str;
  }
  const start = str.slice(STRING_START_INDEX, VISIBLE_CHARACTERS);
  const end = '*'.repeat(length - VISIBLE_CHARACTERS);

  return `${start}${end}`;
}

export const obfuscateEmail = (email: string | undefined): string => {
  if (!email) {
    return '';
  }

  const atIndex = email.indexOf('@');

  if (atIndex === -1) {
    return email;
  }

  const localPart = email.substring(0, atIndex);
  const domain = email.substring(atIndex);
  const localPartLength = localPart.length;

  if (localPartLength <= 3) {
    return `***${domain}`;
  }

  const unmaskedPart = localPart.substring(0, 2);

  return `${unmaskedPart}***${domain}`;
};
